<template>
  <div class="outmain ba_f">
    <div class="market mar_b30" v-if="false">
      <div class="mtitle color_3 fon_14 wei">
        经营渠道
        <span class="fon_12 mar_l10 color_9 fnormal">拓展覆盖渠道</span>
      </div>
      <div class="market-con clearfix">
        <!-- <div
          class="market-item fl wid17 curs pad_r_15 mar_t15"
          @click="jyqd('app')"
        >
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="~@/assets/img/app.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">
                骑手app
                <span class="newIcon bag_green">必看</span>
              </p>
              <p class="overflowlnr fon_12 color_9" title="骑手app">
                下载骑手app
              </p>
            </div>
          </div>
        </div> -->
        <div
          v-if="service_ids.indexOf('app') >= 0"
          class="market-item fl wid17 curs pad_r_15 mar_t15"
          @click="jyqd('wxxcx')"
        >
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="~@/assets/img/wechatSmallPro.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">
                微信小程序
                <span class="newIcon bag_green">必看</span>
              </p>
              <p class="overflowlnr fon_12 color_9" title=""></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="market mar_b30" v-if="false">
      <div class="mtitle color_3 fon_14 wei">
        骑士专区
        <span class="fon_12 mar_l10 color_9 fnormal"
          >骑手相关营销、下单配套功能</span
        >
      </div>
      <div class="market-con clearfix">
        <div
          class="market-item fl wid17 curs pad_r_15 mar_t15 curs"
          @click="yxgn('qsxy')"
        >
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img
                src="../../assets/img/channel/market_icon1.png"
                class="dis_bk"
              />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">骑士学院</p>
              <p class="overflowlnr fon_12 color_9" title="骑士学院">
                骑士学院
              </p>
            </div>
          </div>
        </div>
        <div
          class="market-item fl wid17 curs pad_r_15 mar_t15 curs"
          @click="yxgn('pxdd')"
        >
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="~@/assets/img/px.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">培训地点</p>
              <p class="overflowlnr fon_12 color_9" title="培训地点">
                线下骑手培训报名设置
              </p>
            </div>
          </div>
        </div>
        <div
          class="market-item fl wid17 curs pad_r_15 mar_t15 curs"
          @click="yxgn('phb')"
        >
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img
                src="../../assets/img/channel/market_icon14.png"
                class="dis_bk"
              />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">排行榜</p>
              <p class="overflowlnr fon_12 color_9" title="排行榜">排行榜</p>
            </div>
          </div>
        </div>
        <div
          class="market-item fl wid17 curs pad_r_15 mar_t15 curs"
          @click="yxgn('bzj')"
        >
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img
                src="../../assets/img/channel/market_icon23.png"
                class="dis_bk"
              />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">保证金</p>
              <p class="overflowlnr fon_12 color_9" title="保证金">保证金</p>
            </div>
          </div>
        </div>
        <!-- <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="yxgn('sphd')">
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="../../assets/img/channel/market_icon23.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">
                装备商城
                <span class="newIcon">new</span>
              </p>
              <p class="overflowlnr fon_12 color_9" title="装备商城">装备商城</p>
            </div>
          </div>
        </div>-->
      </div>
    </div>
    <div class="market mar_b30" v-if="false">
      <div class="mtitle color_3 fon_14 wei">
        营销玩法
        <span class="fon_12 mar_l10 color_9 fnormal"
          >吸粉、老客带新客，提高下单转化率</span
        >
      </div>
      <div class="market-con clearfix">
        <!-- <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="yllx('xkzx')">
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="../../assets/img/channel/market_icon7.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">
                优惠券
                <span class="newIcon">new</span>
              </p>
              <p class="overflowlnr fon_12 color_9" title="优惠券">优惠券</p>
            </div>
          </div>
        </div>-->
        <router-link to="/activeCenter">
          <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs">
            <div class="item-wrapper ba_f57a flex rel">
              <div class="pic">
                <img
                  src="../../assets/img/channel/market_icon5.png"
                  class="dis_bk"
                />
              </div>
              <div class="description flex-1 mar_l15">
                <p class="overflowlnr fon_14 color_3">活动中心</p>
                <p class="overflowlnr fon_12 color_9" title="活动中心">
                  活动中心
                </p>
              </div>
            </div>
          </div>
        </router-link>

        <!-- <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="yllx('scyl')">
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="../../assets/img/channel/market_icon25.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">拉新有奖</p>
              <p class="overflowlnr fon_12 color_9" title="拉新有奖">拉新有奖</p>
            </div>
          </div>
        </div>
        <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="yllx('scyl')">
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="../../assets/img/channel/market_icon25.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">多城市</p>
              <p class="overflowlnr fon_12 color_9" title="多城市">多城市</p>
            </div>
          </div>
        </div>-->
      </div>
    </div>
    <div class="market mar_b30">
      <div class="mtitle color_3 fon_14 wei">
        {{ $t('plugin.applicationList.tools') }}
        <span class="fon_12 mar_l10 color_9 fnormal"></span>
      </div>
      <div class="market-con clearfix">
        <!-- <div
          class="market-item fl wid17 curs pad_r_15 mar_t15 curs"
          @click="yxgn('IDSet')"
        >
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="~@/assets/img/zhneg.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">
                身份证识别
                <span class="newIcon fon_12">必配</span>
              </p>
              <p class="overflowlnr fon_12 color_9" title="一键识别身份证号">
                一键识别身份证号
              </p>
            </div>
          </div>
        </div> -->
        <div
          class="market-item fl wid17 curs pad_r_15 mar_t15 curs"
          @click="yxgn('shortSet')"
        >
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="~@/assets/img/dx.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">
                {{ $t('plugin.applicationList.sms') }}
                <span class="newIcon">{{ $t('plugin.applicationList.mustConfig') }}</span>
              </p>
              <p
                class="overflowlnr fon_12 color_9"
                :title="$t('plugin.applicationList.smsDesc')"
              >
                {{ $t('plugin.applicationList.smsDesc') }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="market-item fl wid17 curs pad_r_15 mar_t15 curs"
          @click="yxgn('enclosure')"
        >
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="~@/assets/img/yun.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">{{ $t('plugin.applicationList.remoteAttach') }}</p>
              <p class="overflowlnr fon_12 color_9" :title="$t('plugin.applicationList.remoteAttachDesc')">
                {{ $t('plugin.applicationList.remoteAttachDesc') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="market mar_b30">
      <div class="mtitle color_3 fon_14 wei">
        配套工具
        <span class="fon_12 mar_l10 color_9 fnormal">扫码、核销、调研等</span>
      </div>
      <div class="market-con clearfix">
        <div class="market-item fl wid17 curs pad_r_15 mar_t15" @click="ptgj('xxtz')">
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="../../assets/img/channel/market_icon25.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">消息通知</p>
              <p class="overflowlnr fon_12 color_9" title="向顾客及商家发送信息">向顾客及商家发送信息</p>
            </div>
            <div class="notice-expect ab fon_12 color_f">敬请期待</div>
          </div>
        </div>

        <div class="market-item fl wid17 curs pad_r_15 mar_t15" @click="ptgj('ymlj')">
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="../../assets/img/channel/market_icon25.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">页面链接</p>
              <p class="overflowlnr fon_12 color_9" title="一键生成二维码链接">一键生成二维码链接</p>
            </div>
            <div class="notice-expect ab fon_12 color_f">敬请期待</div>
          </div>
        </div>

        <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="ptgj('kszcxcx')">
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="../../assets/img/channel/market_icon25.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">快速注册小程序</p>
              <p class="overflowlnr fon_12 color_9" title="快速注册小程序">一键快速注册小程序</p>
            </div>
            <div class="notice-expect ab fon_12 color_f">敬请期待</div>
          </div>
        </div>

        <div class="market-item fl wid17 curs pad_r_15 mar_t15 curs" @click="ptgj('yyhc')">
          <div class="item-wrapper ba_f57a flex rel">
            <div class="pic">
              <img src="../../assets/img/channel/market_icon25.png" class="dis_bk" />
            </div>
            <div class="description flex-1 mar_l15">
              <p class="overflowlnr fon_14 color_3">语音合成</p>
              <p class="overflowlnr fon_12 color_9" title="快速注册小程序">百度AI语音合成账号设置</p>
            </div>
            <div class="notice-expect ab fon_12 color_f">敬请期待</div>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
import { getPower } from '@/api/plugins.js';
export default {
  data() {
    return {
      channel_ids: [], // 渠道
      new_ids: [], // 增值balanceRecharge会员储值，signIndex积分签到，integralShop积分商城
      plug_ids: [], // 插件
      service_ids: []
    };
  },
  created() {
    this.getPowerList()
  },
  methods: {
    async getPowerList(){
      const { data } = await getPower()
      this.channel_ids = data.channel_ids ? data.channel_ids : []
      this.new_ids = data.new_ids ? data.new_ids : []
      this.plug_ids = data.plug_ids ? data.plug_ids : []
      this.service_ids = data.service_ids ? data.service_ids : []
    },
    yxgn(type) {
      switch (type) {
        case "pxdd":
          this.$router.push({
            path: "train",
          });
          break;
        case "qsxy":
          this.$router.push({
            path: "learnings",
          });
          break;
        case "phb":
          this.$router.push({
            path: "rankinglist",
          });
          break;
        case "bzj":
          this.$router.push({
            path: "bondlist",
          });
          break;
        case "IDSet":
          this.$router.push({
            name: "IDSet",
          });
          break;
        case "shortSet":
          this.$router.push({
            name: "remind",
          });
          break;
        case "enclosure":
          this.$router.push({
            name: "enclosure",
          });
          break;
        default:
          this.$baseMessage(this.$t('common.comingSoon'), "success");
      }
    },
    jyqd(msg) {
      switch (msg) {
        case "wxxcx": {
          this.$router.push({
            name: "MiniAppSet",
          });
          break;
        }

        case "app": {
          this.$router.push({
            name: "AppSet",
          });
          break;
        }

        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.market .mtitle {
  height: 30px;
  line-height: 30px;
}

.market-con {
  margin-right: -15px;
}

.market-con .item-wrapper {
  padding: 0 10px 0 15px;
  height: 80px;
  /*border-radius: 6px;*/
}

.item-wrapper:hover {
  -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14),
    0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.11);
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 3px 5px -1px rgba(0, 0, 0, 0.11);
}

.pic img {
  width: 40px;
  height: 40px;
}

.notice-expect {
  background: #999;
  padding: 1px 4px;
  right: 0;
  top: 0;
}

.notice-new {
  background: #fc6060;
  padding: 1px 5px;
  right: 0;
  top: 0;
}

.wid17 {
  width: 16%;
  /*width: 250px;*/
  transition: 0.2s all ease;
}

.newIcon {
  width: 34px;
  line-height: 16px;
  padding: 0px 4px;
  margin-left: 5px;
  font-size: 12px;
  color: #fff;
  background-color: #fb6161;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  text-align: center;
}
</style>
